// extracted by mini-css-extract-plugin
export default {"container":"AppContainer_container__NJZX+","stickyFooter":"AppContainer_stickyFooter__gu-hO","spacer":"AppContainer_spacer__DnkSQ"};